import React from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import { Password } from '../steps/Password'

import styles from './styles.module.scss'

const SignupStep = ({ isMobile, title, rightTitle, description, passwordResetKey }) => {
  return (
    <div className={styles.login}>
      <div className={styles.loginContainer}>
        {!isMobile && (
          <div className={styles.loginLeft}>
            <div className={styles.headerLeft}>{rightTitle}</div>
            <div className={styles.descriptionLeft}>{description}</div>
          </div>
        )}
        <div className={styles.loginRight}>
          <div className={styles.titleRight}>{title}</div>
          {isMobile && <div className={styles.descriptionRight}>{description}</div>}
          <Password passwordResetKey={passwordResetKey} />
        </div>
      </div>
    </div>
  )
}

function mapStateToProps(state) {
  const {
    common: { isMobile },
  } = state

  return {
    isMobile,
  }
}

const actionCreators = {}

const ExtendedComponent = withTranslation('common')(SignupStep)

const connectedSignupStep = connect(mapStateToProps, actionCreators)(ExtendedComponent)
export { connectedSignupStep as SignupStep }
